<template>
  <FlotoFixedView>
    <RequestServicePage
      :back-link="
        $currentModule.getRoute('service-list', {
          params: {
            ...($route.params.searchTerm
              ? { searchTerm: $route.params.searchTerm }
              : {}),
          },
        })
      "
      :created-link="
        (id) => $currentModule.getRoute('view-request', { params: { id } })
      "
    />
  </FlotoFixedView>
</template>

<script>
import RequestServicePage from '@modules/service-catalog/views/request-service'

export default {
  name: 'RequestService',
  components: { RequestServicePage },
}
</script>
